import KumosearchError from "./KumosearchError";

export default class ServerError extends KumosearchError {}
